import React from 'react'

function member() {
  return (
    <div>member</div>
  )
}

export default member